import React from 'react'
import Sidebar from './../sidebar'
import { Outlet } from 'react-router-dom'

const index = () => {
  return (
    <>
     <div className='flex'>
        <div className='bg-white shadow-sideShadow z-20 fixed flex flex-row bottom-0 justify-around w-full md:flex md:flex-col md:top-0 md:left-0 md:fixed md:justify-around md:w-2/12 md:h-full'><Sidebar/></div>
        <div className='ml-0 w-full md:ml-[300px] mb-[80px]'><Outlet/></div>
     </div>   
    </>
  )
}

export default index